module.exports = __webpack_public_path__ + "static/media/illustration-section-04.38ff2a3e.svg";